"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushNews = exports.newsTypeByCode = exports.newsListByCodeAndType = exports.newsCode = exports.newTypeListAll = exports.newTypeList = exports.newTypeEdit = exports.newTypeDel = exports.newTypeAdd = exports.newList = exports.newEdit = exports.newAdd = exports.getNewsById = exports.delNews = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取新闻列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var newList = exports.newList = function newList(data) {
  return _api.default.request({
    url: '/news/newsList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增新闻
 * @author kkdy
 * @date 2021-12-01
 * @param {any} data
 * @returns {any}
 */
var newAdd = exports.newAdd = function newAdd(data) {
  return _api.default.request({
    url: '/news/saveNews',
    method: 'post',
    data: data
  });
};
/**
 * 描述 通过id获取新闻纪录
 * @author kkdy
 * @date 2021-12-01
 * @param {any} data
 * @returns {any}
 */
var getNewsById = exports.getNewsById = function getNewsById(data) {
  return _api.default.request({
    url: '/news/newsView',
    method: 'post',
    data: data
  });
};
/**
 * 描述  编辑新闻
 * @author kkdy
 * @date 2021-12-01
 * @param {any} data
 * @returns {any}
 */
var newEdit = exports.newEdit = function newEdit(data) {
  return _api.default.request({
    url: '/news/editNews',
    method: 'post',
    data: data
  });
};
//
/**
 * 描述 获取新闻分类列表(分页)
 * @author kkdy
 * @date 2021-11-24
 * @param {any} data
 * @returns {any}
 */
var newTypeList = exports.newTypeList = function newTypeList(data) {
  return _api.default.request({
    url: '/newsType/newsList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取新闻分类列表(不分页)
 * @author kkdy
 * @date 2021-12-01
 * @param {any} data
 * @returns {any}
 */
var newTypeListAll = exports.newTypeListAll = function newTypeListAll(data) {
  return _api.default.request({
    url: '/newsType/allNewsList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增新闻分类
 * @author kkdy
 * @date 2021-11-24
 * @param {any} data
 * @returns {any}
 */
var newTypeAdd = exports.newTypeAdd = function newTypeAdd(data) {
  return _api.default.request({
    url: '/newsType/saveNewsType',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑新闻分类
 * @author kkdy
 * @date 2021-11-24
 * @param {any} data
 * @returns {any}
 */
var newTypeEdit = exports.newTypeEdit = function newTypeEdit(data) {
  return _api.default.request({
    url: '/newsType/editNewsType',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除新闻分类
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var newTypeDel = exports.newTypeDel = function newTypeDel(data) {
  return _api.default.request({
    url: '/newsType/newsTypeRemove',
    method: 'post',
    data: data
  });
};
/**
 * 描述 批量发布
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var pushNews = exports.pushNews = function pushNews(data) {
  return _api.default.request({
    url: '/news/newsPublish',
    method: 'post',
    data: data
  });
};
/**
 * 描述 批量删除
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var delNews = exports.delNews = function delNews(data) {
  return _api.default.request({
    url: '/news/newsRemove',
    method: 'post',
    data: data
  });
};
/** 
 * 描述 根据省份code获取新闻列表
 * @author kkdy
 * @date 2021-12-02
 * @param {any} data
 * @returns {any}
 */
var newsCode = exports.newsCode = function newsCode(data) {
  return _api.default.request({
    url: '/web/getNewsByCodeAndType',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据省份code获取新闻类型
 * @author kkdy
 * @date 2021-12-02
 * @param {any} data
 * @returns {any}
 */
var newsTypeByCode = exports.newsTypeByCode = function newsTypeByCode(data) {
  return _api.default.request({
    url: '/web/getNewsType',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据省份code和新闻类型获取新闻
 * @author kkdy
 * @date 2021-12-02
 * @param {any} data
 * @returns {any}
 */
var newsListByCodeAndType = exports.newsListByCodeAndType = function newsListByCodeAndType(data) {
  return _api.default.request({
    url: '/web/getNewsByCodeAndType',
    method: 'post',
    data: data
  });
};